<template>
  <div class="separator">
    <span><slot /></span>
  </div>
</template>

<style lang="scss" scoped>
@import '@/uiKit/assets/colors.global.scss';

.separator {
  position: relative;
  width: 100%;
  color: var(--color-border-default);
  display: flex;
  justify-content: center;
  z-index: 0;
  font-size: 0.75em;

  span {
    @include typography(md, inter);
    background: var(--color-surface-default);
    padding: 0 0.5rem;
    color: var(--color-text-subtlest);
  }

  &::before {
    content: '';
    border-top: 1px solid;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    z-index: -1;
  }
}
</style>
